import BaseRestClient from "./base/BaseRestClient";

class FacadeRestClient extends BaseRestClient {
  constructor() {
    super("/facade/api/v1");
  }
}

export const FacadeApi = new FacadeRestClient();
